import React, { useEffect } from 'react'

import { referrals } from 'src/axious/referrals'
import { Header } from 'src/components'
import { useChangeBackground } from 'src/hooks/useChangeBackground'

import { ReferralsList } from '../Referrals/components'
import styles from './ListOfReferrals.module.scss'
import type { ReferralType } from './ListOfReferrals.types'

const ListOfReferrals = () => {
  const [referralsData, setReferralsData] = React.useState<ReferralType[]>([])
  useChangeBackground(styles['white-background'])

  React.useEffect(() => {
    referrals().then((data) => {
      const sorted_referrals = data.sort((a: any, b: any) => b.income_stars - a.income_stars)
      setReferralsData(sorted_referrals)
    })
  }, [])

  return (
    <>
      <Header path='..' variant='settings' setting='My referrals' color='black' />

      <ReferralsList className={styles.list} referralsList={referralsData} />
    </>
  )
}

export default ListOfReferrals
